export default __webpack_public_path__ + "static/media/sidequest.27dd16ba.glb";